// extracted by mini-css-extract-plugin
export default {"container":"SourceBonus_container__iDr-w","chart":"SourceBonus_chart__CEnKn","placeholder":"SourceBonus_placeholder__z2N59"};